import { Component, Input, OnChanges } from '@angular/core';
import { DeveloperModeService } from '@pt/api-client';

export interface SkippedItem {
  chapterId: number;
  chapterName: string;
  groupId: number;
  groupName: string;
  widgetInternalId: number;
  widgetName: string;
  widgetType: string;
  reason: string;
}

interface ChapterGroup {
  chapterId: number;
  chapterName: string;
  items: SkippedItem[];
}

@Component({
  selector: 'pt-duplication-analysis',
  templateUrl: './duplication-analysis.component.html',
  styleUrls: ['./duplication-analysis.component.scss'],
})
export class DuplicationAnalysisComponent implements OnChanges {
  @Input() skippedItems: SkippedItem[] = [];

  chapters: ChapterGroup[] = [];

  trackByChapter = (_: number, c: ChapterGroup) => c.chapterId;
  trackByItem = (_: number, i: SkippedItem) => i.widgetInternalId;

  constructor(public developerModeService: DeveloperModeService) {
  }

  ngOnChanges(): void {
    this.chapters = this.groupByChapter(this.skippedItems ?? []);
  }

  private groupByChapter(items: SkippedItem[]): ChapterGroup[] {
    const map = new Map<number, ChapterGroup>();
    for (const item of items) {
      let group = map.get(item.chapterId);
      if (!group) {
        group = {
          chapterId: item.chapterId,
          chapterName: item.chapterName,
          items: [],
        };
        map.set(item.chapterId, group);
      }
      group.items.push(item);
    }
    return [...map.values()];
  }
}
